"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get replaceLongBaseIds () {
        return replaceLongBaseIds;
    },
    get up () {
        return up;
    }
});
const _nanoid = require("nanoid");
const _globals = require("~/utils/globals");
const log = (message)=>{
    console.log(`nc_054_id_length: ${message}`);
};
let hrTime = process.hrtime();
const logExecutionTime = (message)=>{
    const [seconds, nanoseconds] = process.hrtime(hrTime);
    const elapsedSeconds = seconds + nanoseconds / 1e9;
    log(`${message} in ${elapsedSeconds}s`);
};
const nanoidv2 = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz', 14);
const generateUniqueBaseId = async (knex)=>{
    const baseId = `p${nanoidv2()}`;
    const base = await knex(_globals.MetaTable.PROJECT).where('id', baseId).first();
    if (base) {
        return generateUniqueBaseId(knex);
    }
    return baseId;
};
const listBasesWithLongIds = async (knex)=>{
    const sourceType = knex.client.driverName;
    switch(sourceType){
        case 'pg':
            {
                const bases = await knex.raw(`SELECT id FROM ?? WHERE LENGTH(id) > 20`, _globals.MetaTable.PROJECT);
                return bases.rows.map((row)=>row.id);
            }
        case 'mysql':
        case 'mysql2':
            {
                const bases = await knex.raw(`SELECT id FROM ?? WHERE CHAR_LENGTH(id) > 20`, _globals.MetaTable.PROJECT);
                return bases[0].map((row)=>row.id);
            }
        case 'sqlite3':
            {
                const bases = await knex.raw(`SELECT id FROM ?? WHERE LENGTH(id) > 20`, _globals.MetaTable.PROJECT);
                return bases.map((row)=>row.id);
            }
        default:
            throw new Error(`Unsupported database: ${sourceType}`);
    }
};
const replaceLongBaseIds = async (knex)=>{
    const basesWithLongIds = await listBasesWithLongIds(knex);
    for (const baseId of basesWithLongIds){
        const newBaseId = await generateUniqueBaseId(knex);
        if (!baseId || !newBaseId) {
            throw new Error(`Failed to replace ${baseId} with ${newBaseId}`);
        }
        const tablesToChangeBaseId = [
            _globals.MetaTable.API_TOKENS,
            _globals.MetaTable.AUDIT,
            _globals.MetaTable.PROJECT_USERS,
            _globals.MetaTable.CALENDAR_VIEW_COLUMNS,
            _globals.MetaTable.CALENDAR_VIEW,
            _globals.MetaTable.COLUMNS,
            _globals.MetaTable.COMMENTS_REACTIONS,
            _globals.MetaTable.COMMENTS,
            _globals.MetaTable.MODEL_ROLE_VISIBILITY,
            _globals.MetaTable.EXTENSIONS,
            _globals.MetaTable.FILTER_EXP,
            _globals.MetaTable.FORM_VIEW_COLUMNS,
            _globals.MetaTable.FORM_VIEW,
            _globals.MetaTable.GALLERY_VIEW_COLUMNS,
            _globals.MetaTable.GALLERY_VIEW,
            _globals.MetaTable.GRID_VIEW_COLUMNS,
            _globals.MetaTable.GRID_VIEW,
            _globals.MetaTable.HOOK_LOGS,
            _globals.MetaTable.HOOKS,
            _globals.MetaTable.KANBAN_VIEW_COLUMNS,
            _globals.MetaTable.KANBAN_VIEW,
            _globals.MetaTable.MAP_VIEW_COLUMNS,
            _globals.MetaTable.MAP_VIEW,
            _globals.MetaTable.MODELS,
            _globals.MetaTable.SORT,
            _globals.MetaTable.SOURCES_OLD,
            _globals.MetaTable.SYNC_LOGS,
            _globals.MetaTable.SYNC_SOURCE,
            _globals.MetaTable.USER_COMMENTS_NOTIFICATIONS_PREFERENCE,
            _globals.MetaTable.VIEWS
        ];
        for (const table of tablesToChangeBaseId){
            await knex(table).where('base_id', baseId).update({
                base_id: newBaseId
            });
        }
        await knex(_globals.MetaTable.PROJECT).where('id', baseId).update({
            id: newBaseId
        });
        log(`Replaced ${baseId} with ${newBaseId} (because it was too long)`);
    }
};
const tablesToAlterBaseId = [
    _globals.MetaTable.API_TOKENS,
    _globals.MetaTable.AUDIT,
    _globals.MetaTable.PROJECT_USERS,
    _globals.MetaTable.COLUMNS,
    _globals.MetaTable.COMMENTS_REACTIONS,
    _globals.MetaTable.COMMENTS,
    _globals.MetaTable.MODEL_ROLE_VISIBILITY,
    _globals.MetaTable.FILTER_EXP,
    _globals.MetaTable.FORM_VIEW_COLUMNS,
    _globals.MetaTable.FORM_VIEW,
    _globals.MetaTable.GALLERY_VIEW_COLUMNS,
    _globals.MetaTable.GALLERY_VIEW,
    _globals.MetaTable.GRID_VIEW_COLUMNS,
    _globals.MetaTable.GRID_VIEW,
    _globals.MetaTable.HOOK_LOGS,
    _globals.MetaTable.HOOKS,
    _globals.MetaTable.KANBAN_VIEW_COLUMNS,
    _globals.MetaTable.KANBAN_VIEW,
    _globals.MetaTable.MAP_VIEW,
    _globals.MetaTable.MAP_VIEW_COLUMNS,
    _globals.MetaTable.MODELS,
    _globals.MetaTable.SORT,
    _globals.MetaTable.SOURCES_OLD,
    _globals.MetaTable.SYNC_LOGS,
    _globals.MetaTable.SYNC_SOURCE,
    _globals.MetaTable.USER_COMMENTS_NOTIFICATIONS_PREFERENCE,
    _globals.MetaTable.VIEWS
];
const tablesToAlterSourceId = [
    _globals.MetaTable.CALENDAR_VIEW,
    _globals.MetaTable.CALENDAR_VIEW_COLUMNS
];
const up = async (knex)=>{
    hrTime = process.hrtime();
    await replaceLongBaseIds(knex);
    logExecutionTime('Replaced long base IDs');
    for (const table of tablesToAlterBaseId){
        hrTime = process.hrtime();
        await knex.schema.alterTable(table, (tableQb)=>{
            tableQb.string('base_id', 20).alter();
        });
        logExecutionTime(`Altered ${table}.base_id to 20 characters`);
    }
    for (const table of tablesToAlterSourceId){
        hrTime = process.hrtime();
        await knex.schema.alterTable(table, (tableQb)=>{
            tableQb.string('source_id', 20).alter();
        });
        logExecutionTime(`Altered ${table}.source_id to 20 characters`);
    }
};
const down = async (knex)=>{
    for (const table of tablesToAlterBaseId){
        await knex.schema.alterTable(table, (tableQb)=>{
            tableQb.string('base_id', 128).alter();
        });
    }
    for (const table of tablesToAlterSourceId){
        await knex.schema.alterTable(table, (tableQb)=>{
            tableQb.string('source_id', 128).alter();
        });
    }
};
